//A generic notice prompt
(function(ss, $){
  var utils = ss.utils,

      /* default configuration */
      defaultConfig = {
        onClose: $.noop,
        onHide: $.noop
      },

      /* selectors */
      selectors = {
        close: ".close"
      },

      /* data key to set instance on DOM element */
      ELEMENT_DATA_KEY = 'notice-prompt',

      /**
       * convert Int to String pixels
       * @param {Int} integer value to convert to pixels
       * @private
       */
      toPx = function(pixels){
        return pixels.toString() + "px";
      },

      /**
       * NoticePrompt instance
       * @constructor
       * @param {object} config Configuration for notice prompt
       * @param {String} config.selector selector of parent element
       * @param {function} config.onClose callback for close event
       */
      NoticePrompt = function(config){
        var instance;
        this.config = $.extend(defaultConfig, config);
        this.$el = $(this.config.selector || selectors.container);

        instance = this._getInstance(this.$el);
        if(instance){
          return instance;
        }
        this._init();
      };

  NoticePrompt.prototype = {
    constructor: NoticePrompt,

    /**
     * returns a reusable instance from DOM element
     * @param {object} $el jQuery element
     */
    _getInstance: function($el){
      return $el.data(ELEMENT_DATA_KEY);
    },

    /**
     * Initiate Notice prompt
     * @private
     */
    _init: function(){
      this.$el.data(ELEMENT_DATA_KEY, this);
      this.timeouts = {
        hide: null
      }

      this.$close = $(selectors.close);
      this._attachEventListeners();
    },

    /**
     * Attaches event listeners
     * @private
     */
    _attachEventListeners: function(){
      this.$el.on('click', selectors.close, function(){
        this.hide();
        this.config.onClose.call();
      }.bind(this));
    },

    /**
     * show notice prompt to user
     */
    show: function(){
      var $el = this.$el;

      if($el.css('opacity') === 1) {
        return;
      }

      this.trigger = document.activeElement;

      $el.
        css('opacity', 0).
        removeClass('hide').
        addClass('show').
        css('right', "-" + toPx(this.width())).
        focus();

      $el.animate({
        right: "+=" + this.width(),
        opacity: 1
      });
    },

    /**
     * hide notice prompt
     */
    hide: function(){
      this.$el.
        animate({
          right: "-" + this.width(),
          opacity: 0
        }, function(){
          this.$el.
            removeClass('show').
            addClass('hide');
        }.bind(this));
      if (this.trigger) {
        this.trigger.focus();
      }
      this.config.onHide.call();
    },

    /**
     * determine notice prompt container width
     * @private
     */
    width: function(){
      this.width = this.width || this.$el.width();
      return this.width;
    }
  }

  utils.exports('NoticePrompt', NoticePrompt);
}(window.slideshare_object, jQuery));
